import type { TRuleWithTheme } from '@ackee/fela';

import { ModalType } from '../ModalType';

const typeToContainerMap: Record<ModalType, TRuleWithTheme> = {
    [ModalType.small]: ({ theme }) => ({
        alignItems: 'flex-start',

        width: 'calc(100vw - 5rem)',
        height: 'calc(100vh - 5rem)',
        padding: '2.5rem',

        background: theme.colors.white,

        tablet: {
            width: 'calc(100vw - 8rem)',
            height: 'calc(100vh - 8rem)',

            maxWidth: '58rem',
            maxHeight: '48rem',
        },
    }),
    [ModalType.huge]: ({ theme }) => ({
        padding: '3rem',
        width: 'calc(100vw - 6rem)',
        height: '100%',
        background: theme.colors.white,
        transition: `cubic-bezier(0.4, 0.0, 0.2, 1) transform 300ms`,
    }),
} as const;

export const container: TRuleWithTheme<{ type: ModalType }> = ({ theme, type }, renderer) => ({
    overflow: 'scroll',
    zIndex: 13,
    ...typeToContainerMap[type]({ theme }, renderer),
});

export const header: TRuleWithTheme = () => ({
    position: 'relative',
    height: '4.5rem',
});

export const extendTitle: TRuleWithTheme = ({ theme: { colors } }) => ({
    marginTop: '0.75rem',
    tabletLarge: {
        marginTop: '0.75rem',
    },
});

export const button: TRuleWithTheme = ({ theme: { colors, transition } }) => ({
    fontSize: '1.25rem',
    color: colors.blue,
    paddingTop: '0.75rem',
    paddingBottom: '1.75rem',
    fontWeight: 'bold',

    cursor: 'pointer',

    transition,
    transitionProperty: 'color',

    ':hover': {
        color: colors.fuchsia,
    },
});

export const buttonText: TRuleWithTheme = ({ theme: { colors } }) => ({
    borderBottom: `0.125rem solid ${colors.blue}`,
});

export const closeIconSymetric: TRuleWithTheme = ({ theme: { colors, transition } }) => ({
    position: 'absolute',

    right: '-0.75rem',
    top: '-1.5rem',
    width: '2rem',
    height: '2rem',
    fill: colors.blue,

    cursor: 'pointer',

    transition,
    transitionProperty: 'fill',

    ':hover': {
        fill: colors.fuchsia,
    },
});

export const closeIconWide: TRuleWithTheme = ({ theme: { colors, transition } }) => ({
    fill: colors.blue,
    width: '4rem',
    height: '1.3125rem',

    transition,
    transitionProperty: 'fill',

    cursor: 'pointer',

    ':hover': {
        fill: colors.fuchsia,
    },
});
